import { render, staticRenderFns } from "./CreateDeliveryZone.vue?vue&type=template&id=28d4a99f&"
import script from "./CreateDeliveryZone.vue?vue&type=script&lang=js&"
export * from "./CreateDeliveryZone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports